import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@whilecat/core/loaders/loading-icon.js";
import WhileCatCSS from "@whilecat/core/whilecat-style.js";
import "@whilecat/core/shoe.ts";

@customElement("run-button")
export class RunButton extends LitElement {
    static styles = [
        WhileCatCSS,
        css`
          :host {
            display: block;
            width: 100%;
          }

          sl-button {
            width: 100%;
          }
        `,
    ];

    @property({ type: Boolean }) processing = false;
    @property({ type: Boolean }) disabled = false;
    @property() buttonText = "";
    @property() onClickFunction!: (event?: any) => void | Promise<void>;

    render() {
        if (this.processing) {
            return html`
              <sl-button variant="primary" class="primary" outline ?disabled="${this.disabled}">
                <loading-icon id="loading"></loading-icon>
              </sl-button>
            `;
        }
        return html`
          <sl-button variant="primary"
                     class="primary"
                     outline ?disabled="${this.disabled}" @click="${this.onClickFunction}">
            ${this.buttonText}
            <sl-icon name="arrow-return-right" label="Settings"></sl-icon>
          </sl-button>
        `;
    }
}
